// E.164 phone normalizer (US default). Used for on-blur auto-format in forms so a
// number like "+1 989 930 1722" or "(989) 930-1722" becomes "+19899301722".
export function toE164(s: string | null | undefined): string {
  if (s == null) return '';
  const t = String(s).trim();
  if (!t) return '';
  const plus = t.charAt(0) === '+';
  const d = t.replace(/[^0-9]/g, '');
  if (!d) return '';
  if (plus) return '+' + d;
  if (d.length === 10) return '+1' + d;
  if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
  return '+' + d;
}
